import { forwardRef, ReactElement } from "react";
import Stylesheet from "./style.module.scss";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import SyLoadingIcon from "../../sy-loading-icon";
import Errormessage from "../errormessage/errormessage";
import { styles } from "./input-form-config";
interface InputFormProps {
  placeholder?: string | ReactElement;
  type: "text" | "number" | "email" | "password" | "checkbox" | "radio";
  onChange?: (event: any) => void;
  onInputChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  defaultValue?: string | number;
  value?: any;
  inputFieldWithIcon?: boolean;
  icontype?: string;
  submitLoading?: any;
  handleSubmit?: any;
  onInbutIconClick?: any;
  error?: any;
  click?: any;
  defaultChecked?: any;
  onclick?: any;
  checkboxPlaceholderSide?: "left" | "right";
  displayText?: string | undefined;
  id?: string;
  variant?: "standard" | "outlined" | "filled";
  fieldSize?: "sm" | "md" | 'sm_border';
  errorField?:boolean
  disable?:boolean
}

const InputForm = forwardRef<HTMLInputElement, InputFormProps>(
  (props: InputFormProps, ref) => {
    const {
      placeholder = "",
      type,
      defaultValue,
      onChange,
      onInputChange,
      value,
      inputFieldWithIcon,
      icontype,
      submitLoading,
      disable,
      handleSubmit,
      onInbutIconClick,
      defaultChecked,
      error,
      click,
      onclick,
      checkboxPlaceholderSide = "right",
      fieldSize = "md",
      variant = "outlined",
      id,
      onBlur,
      errorField,
      displayText,
      ...rest
    } = props;

    if (["checkbox","radio"].includes(type)) {
      return (
        <>
          <label className="d-flex">
            {checkboxPlaceholderSide === "left" && (
              <p className="sub-font me-2">{placeholder}</p>
            )}
            <input
              ref={ref}
              type={type}
              className={`${Stylesheet.form_check} me-2 pointer`}
              {...rest}
              onChange={onChange}
              onClick={onclick}
              checked={defaultChecked}
              value={value}
              disabled={disable}
              
            />
            {checkboxPlaceholderSide === "right" && (
              <p className={`${disable? 'opacity-50' :''} sub-font `}>{placeholder}</p>
            )}
          </label>
        </>
      );
    }

    return (
      <>
        {!inputFieldWithIcon && (
          <TextField
            ref={ref}
            fullWidth
            label={placeholder}
            id={id}
            placeholder={displayText}
            defaultValue={defaultValue}
            onChange={onInputChange}
            value={value}
            size="small"
            variant={variant}
            onBlur={onBlur}
            type={type}
            inputProps={styles.input[fieldSize]}
            InputLabelProps={styles.label[fieldSize]}
            sx={styles.sx[fieldSize]}
            error={errorField}
            disabled={disable}
            {...rest}
          />
        )}

        {inputFieldWithIcon && (
          <TextField
            {...rest}
            ref={ref}
            fullWidth
            label={placeholder}
            placeholder={displayText}
            id={id}
            defaultValue={defaultValue}
            onChange={onInputChange}
            value={value}
            size="small"
            type={type}
            onBlur={onBlur}
            variant={variant}
            inputProps={styles.input[fieldSize]}
            InputLabelProps={styles.label[fieldSize]}
            sx={styles.sx[fieldSize]}
            error={errorField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {submitLoading ? (
                    <SyLoadingIcon />
                  ) : (
                    <span
                      className={`${Stylesheet.icon_color} material-icons-round pointer display-none`}
                      onClick={() => {
                        if (value) {
                          onInbutIconClick();
                        }
                      }}
                    >
                      {icontype}
                    </span>
                  )}
                </InputAdornment>
              ),
            }}
          />
        )}

        {error ? (
          <span className="d-flex justify-content-end">
            <Errormessage message={error} />
          </span>
        ) : null}
      </>
    );
  }
);

export default InputForm;
